var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reservation-payment-form" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm.tab.id
          ? _c(
              "div",
              { staticClass: "col" },
              [
                _c("guest-tab", { attrs: { tab: _vm.tab } }),
                _vm._v(" "),
                _vm.tab.stats.balance_due > 0 && _vm.stripeConnected
                  ? _c(
                      "div",
                      {
                        staticClass: "deposit-collection",
                        attrs: { invoiceTabId: _vm.tab.id },
                      },
                      [
                        _vm.tab.id
                          ? _c("collect-deposit", {
                              attrs: {
                                tabId: _vm.tab.id,
                                balance: _vm.tab.stats.balance_due,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.tab.id
          ? _c("b-tooltip", {
              attrs: {
                target: "go-to-payments",
                placement: "top",
                title:
                  "No tab associated with this booking. Please save booking before making payments to it.",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }